import React from "react";
import { trackEvent } from "@/lib/analytics";

const SYNCHRONY_URL = "https://www.synchrony.com/mmc/CR244677105?sitecode=acewel403";

const onClick = (source) => () => trackEvent("Lead", { content_type: "financing", source });

const VerticalCard = ({ testid }) => (
  <a
    href={SYNCHRONY_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="financing-card financing-card-vertical"
    data-testid={testid}
    onClick={onClick(testid.replace("financing-banner-", ""))}
  >
    <div className="financing-card-glow" aria-hidden="true" />
    <span className="financing-card-eyebrow">Synchrony</span>
    <div className="financing-card-headline">
      <span>Get</span>
      <span>repairs</span>
      <em>now.</em>
      <span>Pay</span>
      <span>over</span>
      <em>time.</em>
    </div>
    <ul className="financing-card-bullets" aria-hidden="true">
      <li>0% intro APR*</li>
      <li>Instant decision</li>
      <li>Use in-shop</li>
    </ul>
    <span className="financing-card-cta">
      Apply now <span aria-hidden="true">↗</span>
    </span>
    <span className="financing-card-legal">*Subject to credit approval.</span>
  </a>
);

/**
 * variant:
 *   "sidebar"  — desktop fixed right-rail (≥1024px)
 *   "inline"   — tablet vertical card (768–1023px)
 *   "cta"      — mobile compact card
 */
export default function FinancingBanner({ variant = "sidebar" }) {
  if (variant === "sidebar") {
    return (
      <aside className="financing-sidebar" aria-label="Financing">
        <VerticalCard testid="financing-banner-sidebar" />
      </aside>
    );
  }

  if (variant === "inline") {
    return (
      <div className="financing-inline" data-testid="financing-banner-inline-wrap">
        <VerticalCard testid="financing-banner-inline" />
      </div>
    );
  }

  return (
    <a
      href={SYNCHRONY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="financing-cta"
      data-testid="financing-banner-cta"
      onClick={onClick("cta-card")}
    >
      <span className="financing-cta-eyebrow">Synchrony · Financing</span>
      <strong>Get repairs now. Pay over time.</strong>
      <span className="financing-cta-sub">0% intro APR available. Apply in minutes.</span>
      <span className="financing-cta-arrow" aria-hidden="true">→</span>
    </a>
  );
}
